import * as services from 'services/admin';
import { showSuccessNotification } from 'services/common';

export const SET_ERROR = 'admin/SET_ERROR';
export const CLEAR_ERROR = 'admin/CLEAR_ERROR';
export const REQUEST_STARTED = 'admin/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'admin/REQUEST_SUCCESSFUL';

export const ADD_USER = 'admin/ADD_USER';
export const GET_USERS_FROM_SERVER = 'admin/GET_USERS_FROM_SERVER';
export const SET_USERS = 'admin/SET_USERS';
export const UPDATE_USER_ROLE = 'admin/UPDATE_USER_ROLE';
export const RESET_USER_PASSWORD = 'admin/RESET_USER_PASSWORD';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setUsers = users => ({
  type: SET_USERS,
  users,
});

export const getUsersFromServer = () => dispatch => {
  dispatch(requestStarted());
  services
    .getUsers()
    .then(users => {
      dispatch(setUsers(users));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching users'));
      dispatch(requestCompleted());
    });
};

export const addUser = user => dispatch => {
  dispatch(requestStarted());
  services
    .createUser(user)
    .then(() => {
      dispatch(requestCompleted());
      showSuccessNotification('User has been created successfully.');
      dispatch(getUsersFromServer());
    })
    .catch(error => {
      let errorMessage;
      if (error.response?.data) {
        errorMessage =
          error.response.data?.message || error.response.data?.error?.message;
      } else {
        errorMessage = error.message;
      }
      dispatch(setError(errorMessage));
      dispatch(requestCompleted());
    });
};

export const updateUser = data => dispatch => {
  dispatch(requestStarted());
  services
    .updateUser(data)
    .then(() => {
      dispatch(requestCompleted());
      showSuccessNotification('User has been updated successfully.');
    })
    .catch(error => {
      let errorMessage;
      if (error.response?.data) {
        errorMessage =
          error.response.data?.message || error.response.data?.error?.message;
      } else {
        errorMessage = error.message;
      }
      dispatch(setError(errorMessage));
      dispatch(requestCompleted());
    });
};

export const updateUserRole = data => dispatch => {
  dispatch(requestStarted());
  services
    .updateUserRole(data)
    .then(() => {
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const resetUserPassword = data => dispatch => {
  dispatch(requestStarted());
  services
    .resetUserPassword(data)
    .then(() => {
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteUser = data => dispatch => {
  dispatch(requestStarted());
  services
    .deleteUser(data)
    .then(() => {
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
